import { useMemo } from "react";
import { CONCIERGE_PRODUCT_FORM_CONTAINER_ID } from "../../../concierge/pre-init";
import { log } from "../../../monitoring/log";
import { getAllPdpAddProductForms } from "../../../product-page";
import { isOnProductPage } from "../../../shopify";
import { RedoBackInStockContainerElement } from "./element";

export function useBackInStockRoot(): RedoBackInStockContainerElement[] {
  const backInStockElements = useMemo(() => {
    const onTapcart = !!globalThis.Tapcart && !globalThis.Shopify;
    const hasConciergeContainer = !!document.querySelector(
      CONCIERGE_PRODUCT_FORM_CONTAINER_ID,
    );

    if (!isOnProductPage(onTapcart) && !hasConciergeContainer) {
      return [];
    }

    const forms = getAllPdpAddProductForms({ onTapcart });

    if (forms.length === 0) {
      log("back-in-stock: no forms found");
      return [];
    }

    log(`back-in-stock: embedding in ${forms.length} forms`);

    RedoBackInStockContainerElement.register();

    const elements: RedoBackInStockContainerElement[] = [];

    for (const [index, form] of forms.entries()) {
      const backInStockElement = document.createElement(
        RedoBackInStockContainerElement.TAG,
      ) as RedoBackInStockContainerElement;
      backInStockElement.id = `redo-back-in-stock-container-${index}`;
      form.append(backInStockElement);
      elements.push(backInStockElement);
    }

    return elements;
  }, []);

  return backInStockElements;
}
